import React from 'react'

const LoadingSpinner = ({ size = 'md', text = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  }

  return (
    <div className='loading-container'>
      <div className={`loading-spinner ${sizeClasses[size]}`}></div>
      {text && <span className='loading-text'>{text}</span>}
    </div>
  )
}

export default LoadingSpinner
